import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-responsable-tourism',
  templateUrl: './responsable-tourism.component.html',
  styleUrls: ['./responsable-tourism.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ResponsableTourismComponent {

  public readonly RESPONSABLE_TOURISM: string = 'AFICHE_ESNNA_AGENCIAS_16JUL-01.jpg';
  public readonly RESPONSABLE_TOURISM_PATH: string = 'web/travel/PE/FOOTER';

  constructor() { }

}
